/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const email_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m19.5 14.5-4.453-4.165M4.5 14.5l4.452-4.164m-7.53-5.39A1.525 1.525 0 0 0 1 6v12c0 .828.657 1.5 1.467 1.5h19.066c.81 0 1.467-.672 1.467-1.5V6c0-.413-.163-.787-.427-1.058m-21.15.004A1.446 1.446 0 0 1 2.467 4.5h19.066c.407 0 .775.17 1.04.442m-21.15.004 7.53 5.39m13.62-5.394-7.526 5.393m0 0-1.728 1.238A2.263 2.263 0 0 1 12 12c-.471 0-.931-.149-1.32-.427l-1.728-1.237"
    />
  </svg>
)
export default email_medium
